import metadata from './meta/metadata';
import content from './sections/content';

const translations = {
    content,
};

export const meta = {
    ...metadata,
};

export default translations;